




import { Component, Vue } from "vue-property-decorator";
import { GridColumnTypes, GridColumn } from "@/models/grids/column";

@Component
export default class EntityTypesPage extends Vue {
  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    }
  ];
  endpoint: string = "api/entitytypes";
  primary: string = "idEntityType";
}
